// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --color-around-green: green;
  --color-background-header: rgb(149 196 181);
  --color-border: rgb(170 170 170);
  --panel-min-width: 250px;
  --panel-max-width: calc(min(800px, 100%));
}

.debug {
  color: gray;
  font-size: 0.7em;
  font-style: italic;

  & > span {
    padding-left: 5px;
  }
}

@media (max-width: 992px) {
  .no-mobile {
    display: none;
  }
}

h1 {
  text-align: center;
}

.reduce-width {
  width: min(100%, 800px);
  margin: 0 auto;
}

#menu {
  background-color: #f8f8f8;
  display: flex;
  align-items: center;
  height: 40px;
  border: 1px solid #e7e7e7;
  border-radius: 0;
  margin-bottom: 10px;

  * {
    display: block;
    padding-left: 10px;
    margin-left: 10px;

    img {
      vertical-align: middle;
      margin-right: 5px;
    }
  }

  .action {
    border: 1px solid #ccc;
    border-radius: 4px;
    height: 100%;
    display: flex;
    align-items: center;
    padding: 10px;
  }
}

.with-image {
  display: flex;
  flex-direction: row;

  height: 100%;
  align-items: center;

  * {
    flex-grow: 0;
  }

  div {
    text-align: left;
  }

  img {
    height: 1em;
    padding-right: 0.5em;
  }
}

.fullscreen {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 999;

  padding: 5px;
  background-color: gray;

  object-fit: contain;

  & > * {
    background-color: white;
    max-width: var(--panel-max-width);
    max-height: 100%;
    margin-left: auto;
    margin-right: auto;

    overflow: auto;

    padding: 20px;
    border-radius: 10px;
  }
}

.technical {
  display: flex;
  width: 100%;

  flex-wrap: wrap;
  justify-content: space-between;

  color: gray;
  font-size: 10px;
}

.separator {
  width: 100%;
  background-color: lightgray;
  border: black 1px dashed;
  text-align: center;
}

.comment {
  width: 100%;
  text-align: center;
  font-size: 0.8em;
}

.btn {
  min-width: calc(min(30%, 125px));
}

.action-view {
  background-color: #5bc0de;
  border-color: #46b8da;
  color: white;
}

.action-confirm {
  background-color: #5cb85c;
  border-color: #4cae4c;
  color: white;
}

.action-cancel {
  background-color: #f0ad4e;
  border-color: #eea236;
  color: white;
}

.action-alternate {
  background-color: rgb(50% 50% 50%);
  border-color: rgb(45% 45% 45%);
  color: white;
}

.action-delete {
  background-color: #d9534f;
  border-color: #d43f3a;
  color: white;
}

.action-warning {
  background-color: #f0ad4e;
  border-color: #eea236;
  color: white;
}

.discrete {
  background-color: transparent !important;
  color: black !important;
}

.report-table {
  border-collapse: collapse;
  border-radius: 7px;

  th,
  td {
    border: 1px solid var(--color-border);
    text-align: center;
    vertical-align: middle;
  }

  thead th,
  tfoot th {
    background-color: var(--color-background-header);
  }

  tbody th {
    background-color: gray;
  }

  tbody tr:nth-child(odd) td {
    background-color: lightgray;
  }
}
`, "",{"version":3,"sources":["webpack://./frontend/main.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,2CAA2C;EAC3C,gCAAgC;EAChC,wBAAwB;EACxB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;;EAElB;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;;EAEnB;IACE,cAAc;IACd,kBAAkB;IAClB,iBAAiB;;IAEjB;MACE,sBAAsB;MACtB,iBAAiB;IACnB;EACF;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;;EAEnB,YAAY;EACZ,mBAAmB;;EAEnB;IACE,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,oBAAoB;EACtB;AACF;;AAEA;EACE,eAAe;EACf,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,YAAY;;EAEZ,YAAY;EACZ,sBAAsB;;EAEtB,mBAAmB;;EAEnB;IACE,uBAAuB;IACvB,iCAAiC;IACjC,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;;IAElB,cAAc;;IAEd,aAAa;IACb,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;EACb,WAAW;;EAEX,eAAe;EACf,8BAA8B;;EAE9B,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,wCAAwC;EACxC,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;;EAElB;;IAEE,qCAAqC;IACrC,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;;IAEE,gDAAgD;EAClD;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,2BAA2B;EAC7B;AACF","sourcesContent":[":root {\n  --color-around-green: green;\n  --color-background-header: rgb(149 196 181);\n  --color-border: rgb(170 170 170);\n  --panel-min-width: 250px;\n  --panel-max-width: calc(min(800px, 100%));\n}\n\n.debug {\n  color: gray;\n  font-size: 0.7em;\n  font-style: italic;\n\n  & > span {\n    padding-left: 5px;\n  }\n}\n\n@media (max-width: 992px) {\n  .no-mobile {\n    display: none;\n  }\n}\n\nh1 {\n  text-align: center;\n}\n\n.reduce-width {\n  width: min(100%, 800px);\n  margin: 0 auto;\n}\n\n#menu {\n  background-color: #f8f8f8;\n  display: flex;\n  align-items: center;\n  height: 40px;\n  border: 1px solid #e7e7e7;\n  border-radius: 0;\n  margin-bottom: 10px;\n\n  * {\n    display: block;\n    padding-left: 10px;\n    margin-left: 10px;\n\n    img {\n      vertical-align: middle;\n      margin-right: 5px;\n    }\n  }\n\n  .action {\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    padding: 10px;\n  }\n}\n\n.with-image {\n  display: flex;\n  flex-direction: row;\n\n  height: 100%;\n  align-items: center;\n\n  * {\n    flex-grow: 0;\n  }\n\n  div {\n    text-align: left;\n  }\n\n  img {\n    height: 1em;\n    padding-right: 0.5em;\n  }\n}\n\n.fullscreen {\n  position: fixed;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 999;\n\n  padding: 5px;\n  background-color: gray;\n\n  object-fit: contain;\n\n  & > * {\n    background-color: white;\n    max-width: var(--panel-max-width);\n    max-height: 100%;\n    margin-left: auto;\n    margin-right: auto;\n\n    overflow: auto;\n\n    padding: 20px;\n    border-radius: 10px;\n  }\n}\n\n.technical {\n  display: flex;\n  width: 100%;\n\n  flex-wrap: wrap;\n  justify-content: space-between;\n\n  color: gray;\n  font-size: 10px;\n}\n\n.separator {\n  width: 100%;\n  background-color: lightgray;\n  border: black 1px dashed;\n  text-align: center;\n}\n\n.comment {\n  width: 100%;\n  text-align: center;\n  font-size: 0.8em;\n}\n\n.btn {\n  min-width: calc(min(30%, 125px));\n}\n\n.action-view {\n  background-color: #5bc0de;\n  border-color: #46b8da;\n  color: white;\n}\n\n.action-confirm {\n  background-color: #5cb85c;\n  border-color: #4cae4c;\n  color: white;\n}\n\n.action-cancel {\n  background-color: #f0ad4e;\n  border-color: #eea236;\n  color: white;\n}\n\n.action-alternate {\n  background-color: rgb(50% 50% 50%);\n  border-color: rgb(45% 45% 45%);\n  color: white;\n}\n\n.action-delete {\n  background-color: #d9534f;\n  border-color: #d43f3a;\n  color: white;\n}\n\n.action-warning {\n  background-color: #f0ad4e;\n  border-color: #eea236;\n  color: white;\n}\n\n.discrete {\n  background-color: transparent !important;\n  color: black !important;\n}\n\n.report-table {\n  border-collapse: collapse;\n  border-radius: 7px;\n\n  th,\n  td {\n    border: 1px solid var(--color-border);\n    text-align: center;\n    vertical-align: middle;\n  }\n\n  thead th,\n  tfoot th {\n    background-color: var(--color-background-header);\n  }\n\n  tbody th {\n    background-color: gray;\n  }\n\n  tbody tr:nth-child(odd) td {\n    background-color: lightgray;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
